import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { logoutUser } from "../store/slices/authSlice";
import Sidebar from "./Sidebar";
import Header from "./Header";
import { Footprints } from "lucide-react";
import Footer from "./Footer";
import { useFooter } from "../contexts/FooterContext";

/**
 * Main dashboard layout component with sidebar and header
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child components to render in main content area
 */
const DashboardLayout = ({ children }) => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const { isFooterVisible } = useFooter();
  useEffect(() => {
    if (!user) {
      window.location.href = "/login";
    }
  }, [user]);
  const location = useLocation();

  /**
   * Get current page name based on the current route
   */
  const getCurrentPageName = () => {
    const path = location.pathname;
    // Define route to page name mapping
    const routeMap = {
      "/dashboard": { heading: "Dashboard", subheading: "Dashboard" },
      "/test": { heading: "Test", subheading: "Test" },
      "/alert-services": { heading: "Alert Services", subheading: "Alert Services" },
      "/ai-detection": { heading: "AI Detection", subheading: "Use Cases & Configuration" },
      "/nvr": { heading: "NVR Selection", subheading: "Network Video Recorders" },
      "/user-management/users": {
        heading: "Users",
        subheading: "User Management",
      },
      "/construction-site-management": {
        heading: "Construction Site Management",
        subheading: "Manage construction sites",
      },
    };

    // Check for exact match first
    if (routeMap[path]) {
      return routeMap[path];
    }

    return { heading: "AI Detection", subheading: "Use Cases & Configuration" };

    // // Check for partial matches (for nested routes)
    // for (const [route, pageNameData] of Object.entries(routeMap)) {
    //   if (path.startsWith(route) && route !== '/') {
    //     return pageName;
    //   }
    // }

    // // Default fallback
    // return 'User Management System';
  };

  /**
   * Handle user logout
   */
  const handleLogout = () => {
    dispatch(logoutUser());
  };

  /**
   * Toggle sidebar collapsed state
   */
  const toggleSidebar = () => {
    setSidebarCollapsed((prev) => !prev);
  };

  return (
    <div>
      <div className="dashboard-layout">
        <Sidebar collapsed={sidebarCollapsed} onToggle={toggleSidebar} />

        <div
          className={`main-content ${
            sidebarCollapsed ? "sidebar-collapsed" : ""
          }`}
        >
          <Header
            user={user}
            onLogout={handleLogout}
            onToggleSidebar={toggleSidebar}
            currentPage={getCurrentPageName()}
          />

          <main className="content-area" style={{  }}>
            {children}
          </main>
        </div>
      </div>
      {isFooterVisible && <Footer />}
    </div>
  );
};

export default DashboardLayout;
